import { hasMobileUserAgent } from '@carvana/stc-utilities';

const styles = hasMobileUserAgent()
  ? `
div[class*='ChatTogglestyles'] {
  display: none;
}
div[class*='Chatstyles'] {
  display: none;
}
div[data-qa='hand-raising-positioning-container'] {
  display: none;
}
`
  : `
  @media screen and (max-width: 767px) {
    div[class*='ChatToggleButton'].shift-up {
      bottom: 68px;
      transition: bottom 400ms;
      transition-timing-function: cubic-bezier(0.25, 0.05, 0.22, 0.99);
    }

    div[class*='ChatToggleButton'].shifting-down {
      bottom: 20px;
      transition: bottom 400ms;
      transition-timing-function: cubic-bezier(0.25, 0.05, 0.22, 0.99);
    }
  }
`;

export default styles;
